import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class LandsCadastralCasesApi extends ApiModule {
	constructor() {
		super(ModulesMap.LANDS_CADASTRAL_CASES, {
			entity: 'land_cadastral_cases',
		})
	}
}
